const defaultColors = [
	'#d73d32',
	'#7e3794',
	'#4285f4',
	'#67ae3f',
	'#d61a7f',
	'#ff4080',
]
export function joinName(name: string[]) {
	return name
		.filter((v) => !!v)
		.join(' ')
		.trim()
}
export function getInitials(name: string, maxInitials: number = 2) {
	return name
		.split(/\s/)
		.map((part) => part.substring(0, 1).toUpperCase())
		.filter((v) => !!v)
		.slice(0, maxInitials)
		.join('')
		.toUpperCase()
}
export function _stringAsciiPRNG(value: string, m: number) {
	// Xn+1 = (a * Xn + c) % m
	// 0 < a < m
	// 0 <= c < m
	// 0 <= X0 < m

	const charCodes = [...(value?.split('') || [])].map((letter) =>
		letter.charCodeAt(0)
	)
	const len = charCodes.length

	const a = (len % (m - 1)) + 1
	const c = charCodes.reduce((current, next) => current + next) % m

	let random = charCodes[0] % m
	for (let i = 0; i < len; i++) random = (a * random + c) % m

	return random
}

export function getRandomColor(
	value: string,
	colors: string[] = defaultColors
) {
	// if no value is passed, always return transparent color otherwise
	// a rerender would show a new color which would will
	// give strange effects when an interface is loading
	// and gets rerendered a few consequent times
	if (!value) return 'transparent'

	// value based random color index
	// the reason we don't just use a random number is to make sure that
	// a certain value will always get the same color assigned given
	// a fixed set of colors
	const colorIndex = _stringAsciiPRNG(value, colors.length)

	return colors[colorIndex]
}
